import { render, staticRenderFns } from "./MManualReviewAlert.vue?vue&type=template&id=375a6c8c&lang=pug&"
import script from "./MManualReviewAlert.vue?vue&type=script&lang=js&"
export * from "./MManualReviewAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports